import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { PhotoComponent } from 'src/app/components/photo';

import { AccountsService } from 'src/app/services/accounts.service';

@Component({
    selector: 'account-access-dialog',
    template: `
<div class="account_access_dialog joi-dialog">
  <div mat-dialog-content>
      <icon class="close" aria-label="Close" (click)="dialogRef.close()" matIcon="close"></icon>
      <div class="user">
          <photo [data]="user" [size]="36"></photo>
          <div class="name">
              <div [ngClass]="{invited: user.status=='invited'}">{{user.firstName + ' ' + user.lastName}}</div>
              <div class="sm">{{user.email}}</div>
          </div>
      </div>
      <form #accForm="ngForm">
          <mat-radio-group name="role" class="role_group" [(ngModel)]="user.role" requird [disabled]="data.is_self">
            <mat-radio-button class="role" color="primary" *ngFor="let role of roles" [value]="role.value" [disabled]="role.disabled">
              <div class="label">{{role.label}}</div>
              <div class="desc" *ngFor="let desc of role.desc">{{desc}}</div>
            </mat-radio-button>
          </mat-radio-group>
      </form>
  </div>
  <div mat-dialog-actions *ngIf="!data.is_self">
      <button mat-button class="remove" (click)="dialogRef.close()">CANCEL</button>
      <button mat-button color="primary" [disabled]="accForm.invalid" (click)="dialogRef.close({action: 'save', data: user})">SAVE</button>
  </div>
</div>
  `,
    styleUrls: ['./accounts.dialog.access.scss'],
    standalone: true,
    imports: [MatButtonModule, MatRadioModule, CommonModule, FormsModule, IconComponent, PhotoComponent],
})
export class AccountAccessDialogComponent {

  account;
  roles
  user: any = {email: '', firstName: '', lastName: '', role: 'event'};

  constructor(public dialogRef: MatDialogRef<AccountAccessDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public accountService:AccountsService) {
      this.user = JSON.parse(JSON.stringify(data.user));
      this.account = {...data.acc}
      this.roles = [...this.accountService.roles]
      // console.log('this.account ', this.account);
      if (!this.account.is_admin) {
          const admin_role = this.roles.find(r => r.value === 'admin');
          admin_role['disabled'] = true;
          if (!this.account.is_exec) {
              const exec_role = this.roles.find(r => r.value === 'executive');
              exec_role['disabled'] = true;
          }
      }
  }
}
